import { useState, useEffect, useCallback, useRef } from "react";
import "./ExitIntentFeedback.css"; // ← single CSS import, no inline <style> tag
import React from 'react';
import { submitFeedback  } from '../../graphql/mutations';
import { API, graphqlOperation } from 'aws-amplify';
import { graphql } from "../../utils/api";
import { connect } from 'react-redux';


import {  Auth } from "aws-amplify";
import {
  
  Image,
 
} from '@chakra-ui/react';





// ─── Rating config ────────────────────────────────────────────────────────────
const RATING_LABELS = ["", "Very Poor", "Poor", "Average", "Good", "Excellent"];
const RATING_COLORS = ["", "#ef4444", "#f97316", "#eab308", "#84cc16", "#22c55e"];

// ─── Unique session id ────────────────────────────────────────────────────────
const SESSION_ID =
  sessionStorage.getItem("fb_session") ||
  (() => {
    const id = Math.random().toString(36).slice(2);
    sessionStorage.setItem("fb_session", id);
    return id;
  })();

// ─── Main Component ───────────────────────────────────────────────────────────
  const ExitIntentFeedback = ({user,fetchAndSetUser}) => {
    
    console.log("user123", user);
  const [visible, setVisible]   = useState(false);
  const [comments, setComments] = useState("");
  const [hovered, setHovered]   = useState(0);
  const [selected, setSelected] = useState(0);
  const [step, setStep]         = useState("rate"); // 'rate' | 'loading' | 'success' | 'error'
  const [errorMsg, setErrorMsg] = useState("");
 const triggered = useRef(false);
const overlayRef = useRef(null);

// Popup will be allowed only after 30 seconds
const canShow = useRef(false);

// Tracks whether the user has interacted with the page
const hasInteracted = useRef(false);

  // ── Fire popup once per session ───────────────────────────────────────────
  const show = useCallback(() => {
    if (triggered.current) return;
    triggered.current = true;
    setVisible(true);
  }, []);

useEffect(() => {
  // Wait 30 seconds before allowing popup
  const timer = setTimeout(() => {
    canShow.current = true;
    console.log("✅ Feedback popup is now allowed");
  }, 30000);

  // Detect first user interaction
  const markInteraction = () => {
    if (!hasInteracted.current) {
      hasInteracted.current = true;
      console.log("✅ User interacted with the page");
    }
  };

  window.addEventListener("mousemove", markInteraction, { once: true });
  window.addEventListener("scroll", markInteraction, { once: true });
  window.addEventListener("click", markInteraction, { once: true });
  window.addEventListener("keydown", markInteraction, { once: true });

  // Detect exit intent
  const onMouseLeave = (e) => {
    console.log("Mouse Left:", e.clientY);

    // Ignore if popup already shown
    if (triggered.current) return;

    // User hasn't spent enough time
    if (!canShow.current) return;

    // User never interacted
    if (!hasInteracted.current) return;

    // Mouse really left browser from top
    if (e.clientY <= 10 && e.relatedTarget === null) {
      console.log("🚀 Showing Feedback Popup");
      show();
    }
  };

  document.addEventListener("mouseleave", onMouseLeave);

  return () => {
    clearTimeout(timer);

    window.removeEventListener("mousemove", markInteraction);
    window.removeEventListener("scroll", markInteraction);
    window.removeEventListener("click", markInteraction);
    window.removeEventListener("keydown", markInteraction);

    document.removeEventListener("mouseleave", onMouseLeave);
  };
}, [show]);
// Click outside popup
const handleOverlayClick = (e) => {
  if (e.target === overlayRef.current) {
    dismiss();
  }
};

// Close popup
const dismiss = () => {
  console.log("dismiss called");
 
  setVisible(false);
  setStep("rate");
  setSelected(0);
  setHovered(0);

  
};
useEffect(() => {
  console.log("Redux User:", user);
}, [user])

// Current selected/hovered rating
const activeRating = hovered || selected;



const handleSubmit = async () => {
  try {
    let authMode = "API_KEY";

    try {
      await Auth.currentAuthenticatedUser();
      authMode = "AMAZON_COGNITO_USER_POOLS";
    } catch (err) {
      authMode = "API_KEY";
    }

    const response = await API.graphql({
      query: submitFeedback,
      variables: {
        input: {
          rating: selected,
          comments,
          label: RATING_LABELS[selected],
          sessionId: SESSION_ID,
          userId: user?.userId,
        },
      },
      authMode,
    });

      console.log("Feedback Success:", response);

    setStep("success"); // ← Missing in your code
  } catch (error) {
    console.error(error);

    setErrorMsg(error.message || "Something went wrong");
    setStep("error");
  }
};


if (!visible) return null;

  return (
    <div className="ei-overlay" ref={overlayRef} onClick={handleOverlayClick}>
      <div className="ei-card" role="dialog" aria-modal="true" aria-label="Feedback popup">

        {/* Ambient glow */}
        <div className="ei-glow" />

        {/* Close button */}
       <button
  className="ei-close"
  onClick={() => {
    console.log("close clicked");
    setVisible(false);
  }}
>
  ✕
</button>

        {/* Brand strip */}
        <div className="ei-brand">
          <span className="ei-brand-icon">
            <Image  width={{base:'100px' , md:"120px" , lg :"120px"}} src={require('../../assets/logo/newlogo-small.svg')} />

          </span>
          
        </div>

        {/* ── STEP: Rate ── */}
        {step === "rate" && (
          <>
            <h2 className="ei-title">
              How would you rate your experience with{" "}
              <span className="ei-highlight">1800 Spirits</span> today?
            </h2>

            <div className="ei-stars" role="group" aria-label="Star rating">
              {[1, 2, 3, 4, 5].map((n) => (
                <button
                  key={n}
                  className={`ei-star${n <= activeRating ? " ei-star--lit" : ""}`}
                  style={n <= activeRating ? { color: RATING_COLORS[activeRating] } : {}}
                  onMouseEnter={() => setHovered(n)}
                  onMouseLeave={() => setHovered(0)}
                  onClick={() => setSelected(n)}
                  aria-label={`${n} star — ${RATING_LABELS[n]}`}
                >
                  ★
                </button>
              ))}
            </div>

            <div
              className="ei-label"
              style={{ color: activeRating ? RATING_COLORS[activeRating] : "transparent" }}
            >
              {activeRating ? RATING_LABELS[activeRating] : "—"}
            </div>

            <div className="ei-scale-hint">
              <span>1 — Very Poor</span>
              <span>5 — Excellent</span>
            </div>

   <div className="ei-comment-section">
  <label className="ei-comment-label">
    Tell us more about your experience (Optional)
  </label>

  <textarea
    className="ei-comment-box"
    placeholder="Share your feedback..."
    value={comments}
    onChange={(e) => setComments(e.target.value)}
    maxLength={500}
  />
</div>
         <button className="ei-submit" disabled={!selected} onClick={handleSubmit}>
              Submit Feedback
            </button>
            <p className="ei-skip" onClick={dismiss}>
              No thanks, skip
            </p>
            </>
        )}

        {/* ── STEP: Loading ── */}
        {step === "loading" && (
          <div className="ei-state">
            <div className="ei-spinner" />
            <p className="ei-state-text">Submitting your feedback…</p>
          </div>
        )}

        {/* ── STEP: Success ── */}
        {step === "success" && (
          <div className="ei-state">
            <div className="ei-check">✓</div>
            <h3 className="ei-state-heading">Thank you!</h3>
            <p className="ei-state-text">
              Your feedback helps us craft a better experience.
            </p>
            <button className="ei-submit" onClick={dismiss}>
              Close
            </button>
          </div>
        )}

        {/* ── STEP: Error ── */}
        {step === "error" && (
          <div className="ei-state">
            <div className="ei-error-icon">!</div>
            <h3 className="ei-state-heading">Oops</h3>
            <p className="ei-state-text">{errorMsg}</p>
            <button
              className="ei-submit"
              onClick={() => { setStep("rate"); setErrorMsg(""); }}
            >
              Try Again
            </button>
          </div>
        )}

      </div>
    </div>
  );
}
const stateMapper = (state) => ({
  user: state.auth?.user,

});

const dispatchMapper = (dispatch) => ({
 
  fetchAndSetUser: dispatch.auth.fetchAndSetUser,
  
});
export default connect(stateMapper, dispatchMapper)(ExitIntentFeedback);